import { html } from "lit";
import { ifDefined } from "lit/directives/if-defined.js";
import { formatHtml } from "@trumpf/ux.common-storybook";

export default {
    title: "Components/SearchBar",
    parameters: {
        docs: {
            source: {
                transform: formatHtml,
            },
        },
    },
    component: "ux-iws-search-bar",
    args: {
        buttonText: "",
        compact: "false",
        name: "q",
        navTabContainerSelector: "",
        noContent: "false",
        noInitialFocus: "false",
        noPadding: "false",
        noSticky: "false",
        placeholder: "",
        preventAutomaticScroll: "false",
        resultTabContainerSelector: "",
        searchFormSelector: "",
        searchString: "",
        quickLinksEndpoint: "",
        quickLinksLabel: "",
        curatedSearchLabel: "",
        autosuggestEndpoint: "",
    },
    argTypes: {
        buttonText: { control: "string" },
        compact: { control: "boolean" },
        name: { control: "string" },
        navTabContainerSelector: { control: "string" },
        noContent: { control: "boolean" },
        noInitialFocus: { control: "boolean" },
        noPadding: { control: "boolean" },
        noSticky: { control: "boolean" },
        placeholder: { control: "string" },
        preventAutomaticScroll: { control: "boolean" },
        resultTabContainerSelector: { control: "string" },
        searchFormSelector: { control: "string" },
        searchString: { control: "string" },
        autosuggestEndpoint: {
            control: "select",
            options: ["", "./mock-data/search-bar/autocomplete-tru.json"],
        },
        quickLinksEndpoint: {
            control: "select",
            options: ["", "./mock-data/search-bar/quicklinks.json"],
        },
    },
};

const Template = ({
    buttonText,
    compact,
    name,
    navTabContainerSelector,
    noContent,
    noInitialFocus,
    noPadding,
    noSticky,
    placeholder,
    preventAutomaticScroll,
    resultTabContainerSelector,
    searchFormSelector,
    searchString,
    quickLinksEndpoint,
    quickLinksLabel,
    curatedSearchLabel,
    autosuggestEndpoint,
    resultsLabel,
}) => html`
    <form>
        <ux-iws-search-bar
            button-text="${buttonText}"
            compact="${compact}"
            name="${name}"
            nav-tab-container-selector="${navTabContainerSelector}"
            no-content="${noContent}"
            no-initial-focus="${noInitialFocus}"
            no-padding="${noPadding}"
            no-sticky="${noSticky}"
            placeholder="${placeholder}"
            prevent-automatic-scroll="${preventAutomaticScroll}"
            result-tab-container-selector="${resultTabContainerSelector}"
            search-form-selector="${searchFormSelector}"
            search-string="${searchString}"
            quick-links-endpoint="${quickLinksEndpoint}"
            quick-links-label="${ifDefined(quickLinksLabel)}"
            curated-search-label="${ifDefined(curatedSearchLabel)}"
            autosuggest-endpoint="${autosuggestEndpoint}"
            results-label="${ifDefined(resultsLabel)}"
        ></ux-iws-search-bar>
    </form>
`;

export const Default = Template.bind({});
Default.args = {
    buttonText: "search",
    compact: "false",
    name: "q",
    navTabContainerSelector: "",
    noContent: "false",
    noInitialFocus: "false",
    noPadding: "false",
    noSticky: "false",
    placeholder: "",
    preventAutomaticScroll: "false",
    resultTabContainerSelector: "",
    searchFormSelector: "",
    searchString: "",
    quickLinksEndpoint: "./mock-data/search-bar/quicklinks.json",
    quickLinksLabel: "Quicklinks",
    curatedSearchLabel: "Recently Searched",
    autosuggestEndpoint: "./mock-data/search-bar/autocomplete-tru.json",
    resultsLabel: "Suggestions",
};
